import React from 'react';
import { CheckIcon } from 'lucide-react';
interface ChoiceButtonProps {
  label: string;
  description?: string;
  selected: boolean;
  onClick: () => void;
}

/**
 * Large, thumb-friendly answer button. Choice questions advance the moment one
 * of these is tapped, so there is no separate Continue to reach.
 */
export function ChoiceButton({
  label,
  description,
  selected,
  onClick
}: ChoiceButtonProps) {
  return <button type="button" onClick={onClick} aria-pressed={selected} className={`w-full text-left px-5 py-5 rounded-2xl border transition-[background-color,border-color,transform] duration-200 ease-out hover:scale-[1.01] ${selected ? 'border-primary-500 bg-primary-50 dark:bg-primary-500/10' : 'border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 hover:border-primary-400 dark:hover:border-primary-500/50'}`} data-id="element-183" data-mp="169447oxfz8ff">
      <span className="flex items-center justify-between gap-4" data-id="element-184" data-mp="ihoxzl2jo6yw">
        <span className="min-w-0" data-id="element-185" data-mp="3k6frsoy34n2h">
          <span className="block text-lg font-semibold text-slate-900 dark:text-white" data-id="element-186" data-mp="3k5ehwnst26mc">
            {label}
          </span>
          {description && <span className="block mt-1 text-sm text-slate-500 dark:text-slate-400" data-id="element-187" data-mp="3tw93dpy8926q">
              {description}
            </span>}
        </span>
        <span className={`flex-shrink-0 flex items-center justify-center w-6 h-6 rounded-full border ${selected ? 'bg-primary-500 border-primary-500' : 'border-slate-300 dark:border-white/20'}`} data-id="element-188" data-mp="2omw7ncauhl4">
          {selected && <CheckIcon className="w-4 h-4 text-white" data-id="element-189" data-mp="3b4q1jmfxvu6a" />}
        </span>
      </span>
    </button>;
}